import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@altios/theme/tokens.css';
import { App } from './App';
import './site.css';

const SITE_THEME_KEY = 'altios-site-theme';

function initializeSiteTheme() {
  const stored = window.localStorage.getItem(SITE_THEME_KEY);
  const theme = stored === 'light' ? 'light' : 'dark';

  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;

  return theme;
}

initializeSiteTheme();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);